<template>
  <LaunchpadLoader
    v-if="isAuthLoading || !selectedAccommodationId"
    class="tw:w-full tw:flex tw:justify-center tw:items-center tw:flex-1"
  />
  <div v-else-if="isError" class="tw:flex tw:justify-center tw:items-center tw:flex-1">
    <ErrorModal
      :allow-retry="false"
      :app-name="'Business Studio+'"
      :use-app-name="true"
      header-key="onboarding.appLaunchError.header"
      content-key="onboarding.appLaunchError.text"
      retry-key="onboarding.appLaunchError.retryButton"
    />
  </div>
  <StudioPlusInsightsContainer v-else />
  <FullScreenLoader v-show="isAuthFetching" />
</template>

<script setup>
/**
 * Studio Plus Insights View
 *
 * Access control is handled by route meta:
 *   meta: { requires: { hasStudioPlus: true } }
 *
 * This component only handles loading/error states and rendering.
 */

import LaunchpadLoader from '@/components/dashboard/common/LaunchpadLoader.vue'
import ErrorModal from '@/components/dashboard/ErrorModal.vue'
import StudioPlusInsightsContainer from '@/components/studioPlus/insights/StudioPlusInsightsContainer.vue'
import FullScreenLoader from '@/components/base/loaders/FullScreenLoader.vue'

import { selectedAccommodationId } from '@/layouts/queries'
import { useStudioPlusAuth } from '@/composables/useStudioPlusAuth'

const { isAuthLoading, isAuthFetching, isError } = useStudioPlusAuth()
</script>
